import { Injectable, computed, inject, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, map, throwError, delay, filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CoreService } from 'src/app/shared/services/core-service.service';
import { TipoID, TipoIDResp, TipoIDUpdate } from '../interfaces/tipo-id.interface';
import { SpinnerService } from './spinner.service';

@Injectable({providedIn: 'root'})
export class TypeDocIDService {

  private _typeID = signal<TipoIDResp | any>('');
  public typeID$ = computed(() => this._typeID());

  private http                    = inject(HttpClient);
  private coreService             = inject(CoreService);
  private spinnerService          = inject(SpinnerService);

  private baseUrl: string = environment.baseUrlAuth;

  initialize() {
    const authToken = localStorage.getItem('token');
    if (authToken) {
      this.fetchTypeID();
    } else {
      console.error('No hay token de autenticación');
    }
  }

  private getAuthHeaders(): { headers: HttpHeaders } {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    });

    return { headers };
  }


  getTypeID(): Observable<TipoIDResp[]> {
    const apiUrl = `${this.baseUrl}/api/auth/tipos-id`;
    const {headers} = this.getAuthHeaders();

    return this.http.get<TipoIDResp[]>(apiUrl, {headers})
    .pipe(
      // tap( resp => console.log(resp) )
      map((resp: TipoIDResp[]) => resp),
      catchError( err => {
        this.coreService.openErrorSnackbar(`Error al cargar los tipos de ID ${err.error.message}`, 'OK');
        return throwError(() => err.error.message);
      })

      );
  }

  private fetchTypeID(): void {
    const apiUrl = `${this.baseUrl}/api/auth/tipos-id`;
    const {headers} = this.getAuthHeaders();

    this.spinnerService.show();
    this.http.get<TipoIDResp[]>(apiUrl, { headers })
    .pipe(
      // filtrar respuesta para solo los typeID activos y no eliminados
      map((resp: TipoIDResp[]) => resp.filter( (typeID: TipoIDResp) => typeID.isActive === true)),
      catchError(err => {
        this.coreService.openErrorSnackbar(`Error al obtener la lista de usuario activos: ${err.error.message}`, 'Ok');
        return throwError(() => err);
      })
    ).subscribe({
      next: (response: TipoIDResp[]) => {
        this.spinnerService.hide();
        // Almacena la respuesta en la variable privada de caché
        this._typeID.set(response);
      },
      error: (err) => {
        console.error('Error al obtener la lista de usuario activos:', err);
        this.coreService.openErrorSnackbar(`Error al obtener la lista de usuario activos: ${err.error.message}`, 'Ok');
      },
      complete: () => {
        this.spinnerService.hide();
      }
    }
    );
  }

  public updateFecthTypeID(): void {
    this.fetchTypeID();
  }


  getTypeIDActive(): Observable<TipoIDResp[]> {
    const apiUrl = `${this.baseUrl}/api/auth/tipos-id`;
    const {headers} = this.getAuthHeaders();

    return this.http.get<TipoIDResp[]>(apiUrl, {headers})
    .pipe(
      // tap( resp => console.log(resp) )
      map((resp: TipoIDResp[]) => resp.filter( (typeID: TipoIDResp) => typeID.isActive === true)),
      catchError( err => {
        this.coreService.openErrorSnackbar(`Error al cargar los tipos de ID ${err.error.message}`, 'OK');
        return throwError(() => err.error.message);
      })

      );
  }


  addTypeID(body: TipoID): Observable<TipoID[]> {
    const apiUrl = `${this.baseUrl}/api/auth/tipo-id`;
    const {headers} = this.getAuthHeaders();
    return this.http.post<TipoID[]>(apiUrl, body, {headers})
    .pipe(
      // tap( resp => console.log(resp) )
      map((resp: TipoID[]) => resp),
      catchError( err => {
        this.coreService.openErrorSnackbar(`Error al crear el tipo de ID ${err.error.message}`, 'OK');
        return throwError(() => err.error.message);
      })

      );
  }


  updateTypeID(id: string, body: TipoIDUpdate): Observable<TipoIDUpdate[]> {
    const apiUrl = `${this.baseUrl}/api/auth/tipo-id/?id=${id}`;
    const {headers} = this.getAuthHeaders();

    return this.http.put<TipoIDUpdate[]>(apiUrl, body, {headers})
    .pipe(
      // tap( resp => console.log(resp) )
      map((resp: TipoIDUpdate[]) => resp),
      catchError( err => {
        this.coreService.openErrorSnackbar(`Error al actualizar el tipo de ID ${err.error.message}`, 'OK');
        return throwError(() => err.error.message);
      })

      );
  }

}
